/**
 * PROJECT-STEP-CONTEXT
 * Lets a line of alert open another step of the project (provided by the screen of the project)
 */
import { createContext } from "react"
import { ProjectStep } from "@/redux/project.types"

export interface ProjectStepContextValue {
  openStep: (step: ProjectStep) => void //Opens the step (never closes it) and scrolls to it
}

export const ProjectStepContext = createContext<ProjectStepContextValue>({ openStep: () => {} })
